<template>
  <div class="inputItem">
    <!-- <span class="input-name">{{ title }}</span> -->
    <el-input @input="changeAction(name, formValue)" v-model="formValue" :placeholder="title" />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
    changeAction: {
      type: Function,
      defaut: () => {}
    },
    inputData: {
      type: [String, Number]
    }
  },
  data() {
    return {
      formValue: ""
    };
  },
  watch: {
    inputData() {
      this.formValue = this.inputData;
    }
  },
};
</script>

<style scoped lang="less">
.inputItem {
  float: left;
  margin: 15px 10px 0 0;

  &:last-child {
    margin-right: 0;
  }

  .input-name,
  .el-input {
    float: left;
  }

  .input-name {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin: 0 10px 0 0;
    padding: 0;
  }

  .el-input {
    width: auto;
  }
}
</style>
